const openNftsListNewTab = () => {
  window.open('https://www.eternalvikings.com/qualified-list', '_blank', 'noopener,noreferrer');
  window.location.reload();
};

export default openNftsListNewTab;
